"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BL_ORDER_DOCUMENT_TYPE_TO_SECTION = exports.BL_ORDER_DUAL_SECTION_TYPES = exports.BL_ORDER_SECTION_LABELS = exports.blOrderSectionSchema = exports.BL_ORDER_SECTIONS = void 0;
exports.isDualSectionType = isDualSectionType;
exports.sectionForDocumentType = sectionForDocumentType;
exports.generatedSectionForDocumentType = generatedSectionForDocumentType;
const zod_1 = require("zod");
exports.BL_ORDER_SECTIONS = ['buyer', 'supplier', 'internal'];
exports.blOrderSectionSchema = zod_1.z.enum(exports.BL_ORDER_SECTIONS);
exports.BL_ORDER_SECTION_LABELS = {
    buyer: 'Buyer Deal Documents',
    supplier: 'Supplier Deal Documents',
    internal: 'Internal Documents',
};
// Document types that legitimately live in *more than one* section, where the
// section is decided by the originating flow rather than the type. A Packing
// List or Certificate of Origin we *generate* belongs to the buyer (we issue it
// to the buyer); the *same* document type *uploaded* on the Supplier card is the
// one the supplier sent us and belongs to the supplier. Both rows coexist. For
// these types `sectionForDocumentType` returns null, forcing callers
// (generation / upload) to supply the section explicitly.
exports.BL_ORDER_DUAL_SECTION_TYPES = [
    'packing_list',
    'certificate_of_origin',
];
function isDualSectionType(documentType) {
    return exports.BL_ORDER_DUAL_SECTION_TYPES.includes(documentType);
}
// Fallback single-section home per type. On the upload path the bucket the
// operator filed into wins (#1584); this map is only the default for section-less
// uploads (slot-targeted / programmatic). For the dual-section types the listed
// value is their *upload* (supplier) home and is NOT the source of truth — the
// section is resolved per-flow via `sectionForDocumentType` (null → caller
// decides) and `generatedSectionForDocumentType`.
exports.BL_ORDER_DOCUMENT_TYPE_TO_SECTION = {
    annex_vii: 'supplier',
    bank_certificate: 'supplier',
    bill_of_lading: 'buyer',
    cmr: 'buyer',
    multimodal_bill_of_lading: 'buyer',
    weighbridge_ticket: 'buyer',
    bl_instruction: 'buyer',
    booking_confirmation: 'buyer',
    certificate_of_origin: 'supplier',
    commercial_invoice: 'supplier',
    confirmed_loading_schedule: 'supplier',
    final_invoice: 'buyer',
    freight_certificate: 'buyer',
    freight_insurance: 'buyer',
    inspection_certificate: 'supplier',
    internal_document: 'internal',
    loading_ticket: 'supplier',
    non_radioactive_certificate: 'buyer',
    packing_list: 'supplier',
    proforma_invoice: 'supplier',
    provisional_invoice: 'buyer',
    supplier_document: 'supplier',
    weight_certificate: 'supplier',
};
// Returns the fixed section for single-section types, or null when the caller
// must decide: `other` (operator picks) and the dual-section types (flow picks).
function sectionForDocumentType(documentType) {
    if (documentType === 'other')
        return null;
    if (isDualSectionType(documentType))
        return null;
    return exports.BL_ORDER_DOCUMENT_TYPE_TO_SECTION[documentType];
}
// Section a *generated* document of this type belongs to. Foundry only ever
// generates buyer-side documents (the generate UI lives on the Buyer card), so
// the dual-section types resolve to 'buyer' here. Single-section types keep
// their fixed home; an untyped `other` generation falls back to 'internal'
// (mirrors the historical `?? 'internal'` at the generation site).
function generatedSectionForDocumentType(documentType) {
    if (documentType === 'other')
        return 'internal';
    if (isDualSectionType(documentType))
        return 'buyer';
    return exports.BL_ORDER_DOCUMENT_TYPE_TO_SECTION[documentType];
}
//# sourceMappingURL=bl-order-document-type-to-section.js.map